import {
  WIRCreateJourneyStepsKeys,
  WIRFinalWIRSectionKey,
  WIRFinalWIRSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

export const getFinalWirSections = (wir: WIR | null, country: string) =>
  (wir &&
    Object.keys(WIRFinalWIRSections).map(item => ({
      label: WIRFinalWIRSections[item as WIRFinalWIRSectionKey],
      value: item,
      phase:
        country === CountryData.congo
          ? WIRCreateJourneyStepsKeys.CG_FINAL_WIR
          : WIRCreateJourneyStepsKeys.FINAL_WIR,
    }))) ??
  [];
